import type { StorageQuotaStatus } from "@lib/storage";
import { useStorageStore } from "@lib/storageStore";

export function useStorageQuota(): StorageQuotaStatus {
  return useStorageStore();
}
